module.exports = __webpack_public_path__ + "img/self.49bc7da4.png";